export type SupportedLocale =
  | 'zh-CN'
  | 'en-US'
  | 'ja'
  | 'ko'
  | 'de'
  | 'es'
  | 'zh-TW'
  | 'id'
  | 'ms'
  | 'th';

type MessageSchema = {
  FrequentlyAskedQuestions: string;
  all: string;
  SubmitFeedback: string;
  homePage: string;
  feedbackType: string;
  contactMethod: string;
  contactMobile: string;
  contactWechat: string;
  contactQq: string;
  contactLine: string;
  contactEmail: string;
  contactPlaceholder: string;
  ContactCannotBeEmpty: string;
  Helpful: string;
  NotHelpful: string;
  NotSubmittedYet: string;
  FeedbackList: string;
  submitSuccess: string;
  submitSuccessDescPrefix: string;
  gotIt: string;
  NoMore: string;
  FeedbackDetails: string;
  feedbackDescRequired: string;
  SubmissionTime: string;
  ProcessingStatus: string;
  FeedbackResponse: string;
  submit: string;
  appendReply: string;
  NoResponseReceived: string;
  OperationSuccessful: string;
  HasYourFeedbackBeenResolved: string;
  NotResolved: string;
  Resolved: string;
  mobileInvalid: string;
  IssueImage: string;
  uploadImagesMax3: string;
  chooseFeedbackType: string;
  contentRequired: string;
  contentMin5: string;
  Pending: string;
  Processed: string;
  emailInvalid: string;
  Processing: string;
  UnknownStatus: string;
  Loading: string;
  Requestfailed: string;
  allowEnter: string;
  allow: string;
  deny: string;
  CustomerSupport: string;
  feedbackDescPlaceholder: string;
  replyRequired: string;
  myFeedback: string;
  submitSuccessDescSuffix: string;
  HelpFeedback: string;
};

export const messages: Record<SupportedLocale, MessageSchema> = {
  'zh-CN': {
    FrequentlyAskedQuestions: '常见问题',
    all: '全部',
    SubmitFeedback: '提交反馈',
    homePage: '首页',
    feedbackType: '问题类型',
    contactMethod: '联系方式',
    contactMobile: '手机号',
    contactWechat: '微信',
    contactQq: 'QQ',
    contactLine: 'Line',
    contactEmail: '邮箱',
    contactPlaceholder: '请输入',
    submit: '提交',
    mobileInvalid: '手机号输入有误',
    emailInvalid: '邮箱输入有误',
    ContactCannotBeEmpty: '联系方式不能为空',
    Helpful: '有帮助',
    NotHelpful: '没帮助',
    NotSubmittedYet: '你暂未提交任何反馈',
    FeedbackList: '反馈列表',
    submitSuccess: '提交成功',
    submitSuccessDescPrefix: '感谢您的反馈，您可以在',
    gotIt: '知道了',
    NoMore: '没有更多了',
    FeedbackDetails: '反馈详情',
    feedbackDescRequired: '问题描述',
    SubmissionTime: '提交时间',
    ProcessingStatus: '处理状态',
    FeedbackResponse: '反馈回复',
    appendReply: '追加回复',
    NoResponseReceived: '暂未收到回复',
    OperationSuccessful: '操作成功',
    HasYourFeedbackBeenResolved: '您的反馈是否得到解决？',
    NotResolved: '未解决',
    Resolved: '已解决',
    IssueImage: '问题图片',
    uploadImagesMax3: '上传图片（最多3张）',
    chooseFeedbackType: '请选择反馈类型',
    contentRequired: '内容不能为空',
    contentMin5: '内容不能少于5字',
    Pending: '待处理',
    Processed: '已处理完成',
    Processing: '处理中',
    UnknownStatus: '未知状态',
    Loading: '加载中',
    Requestfailed: '请求失败，点击重新加载',
    allowEnter: '是否允许访问系统相册和相机，用于意见反馈中的附带图片',
    allow: '允许',
    deny: '拒绝',
    CustomerSupport: '客服',
    feedbackDescPlaceholder: '请填写5字以上描述，以便我们更好地为您提供帮助',
    replyRequired: '回复内容（必填）',
    myFeedback: '我的反馈',
    submitSuccessDescSuffix: '页面查看问题回复',
    HelpFeedback: '帮助与反馈'
  },
  'en-US': {
    FrequentlyAskedQuestions: 'FAQ',
    all: 'All',
    SubmitFeedback: 'Submit',
    homePage: 'Home',
    feedbackType: 'Issue Type',
    contactMethod: 'Contact Information',
    contactMobile: 'Phone Number',
    contactWechat: 'WeChat',
    contactQq: 'QQ',
    contactLine: 'Line',
    contactEmail: 'Email',
    contactPlaceholder: 'Please Enter',
    submit: 'Submit',
    mobileInvalid: 'Invalid Phone Number',
    emailInvalid: 'Invalid Email Address',
    ContactCannotBeEmpty: 'Contact Information Cannot Be Empty',
    Helpful: 'Helpful',
    NotHelpful: 'Not Helpful',
    NotSubmittedYet: 'You have not submitted any feedback yet',
    FeedbackList: 'Feedback List',
    submitSuccess: 'Submission Successful',
    submitSuccessDescPrefix:
      'Thank you for your feedback. You can view the response on the ',
    gotIt: 'Understood',
    NoMore: 'No More',
    FeedbackDetails: 'Feedback Details',
    feedbackDescRequired: 'Issue description',
    SubmissionTime: 'Submission Time',
    ProcessingStatus: 'Processing Status',
    FeedbackResponse: 'Feedback Response',
    appendReply: 'Additional Response',
    NoResponseReceived: 'No Response Received Yet',
    OperationSuccessful: 'Operation Successful',
    HasYourFeedbackBeenResolved: 'Has Your Feedback Been Resolved?',
    NotResolved: 'Not Resolved',
    Resolved: 'Resolved',
    IssueImage: 'Issue Image',
    uploadImagesMax3: 'Upload Image (Up to 3)',
    chooseFeedbackType: 'Please Select Feedback Type',
    contentRequired: 'Content Cannot Be Empty',
    contentMin5: 'Content Must Be At Least 5 Characters',
    Pending: 'Pending',
    Processed: 'Processed',
    Processing: 'Processing',
    UnknownStatus: 'Unknown status',
    Loading: 'Loading',
    Requestfailed: 'Request failed, click to reload',
    allowEnter:
      'Allow access to your photos and camera for attaching images in feedback',
    allow: 'Allow',
    deny: 'Deny',
    CustomerSupport: 'Customer Support',
    feedbackDescPlaceholder:
      'Please enter a description of at least 5 characters to help us assist you better',
    replyRequired: 'Response Content (Required)',
    myFeedback: 'My Feedback',
    submitSuccessDescSuffix: 'page.',
    HelpFeedback: 'Help and Feedback'
  },
  ja: {
    FrequentlyAskedQuestions: 'よくある質問',
    all: 'すべて',
    SubmitFeedback: '送信する',
    homePage: 'ホーム',
    feedbackType: '問題の種類',
    contactMethod: '連絡先',
    contactMobile: '電話番号',
    contactWechat: 'ワイチャット',
    contactQq: 'QQ',
    contactLine: 'Line',
    contactEmail: 'メール',
    contactPlaceholder: '入力してください',
    submit: '送信',
    mobileInvalid: '電話番号が無効です',
    emailInvalid: 'メールアドレスが無効です',
    ContactCannotBeEmpty: '連絡先は必須です',
    Helpful: '役に立ちました',
    NotHelpful: '役に立ちませんでした',
    NotSubmittedYet: 'まだフィードバックを送信していません',
    FeedbackList: 'フィードバック一覧',
    submitSuccess: '送信成功',
    submitSuccessDescPrefix:
      'ご意見ありがとうございます。ユーザーフィードバックページで返信をご覧いただけます：',
    gotIt: 'わかりました',
    NoMore: 'これ以上ありません',
    FeedbackDetails: 'フィードバック詳細',
    feedbackDescRequired: '問題の説明',
    SubmissionTime: '送信時間',
    ProcessingStatus: '処理状況',
    FeedbackResponse: 'フィードバック返信',
    appendReply: '追加返信',
    NoResponseReceived: '返信がまだ届いていません',
    OperationSuccessful: '操作成功',
    HasYourFeedbackBeenResolved: 'ご意見は解決されましたか？',
    NotResolved: '未解決',
    Resolved: '解決済み',
    IssueImage: '問題画像',
    uploadImagesMax3: '画像をアップロード（最大3枚）',
    chooseFeedbackType: 'フィードバックの種類を選択してください',
    contentRequired: '内容は必須です',
    contentMin5: '5文字以上の内容が必要です',
    Pending: '未処理',
    Processed: '処理済み',
    Processing: '処理中',
    UnknownStatus: '不明な状態',
    Loading: '読み込み中',
    Requestfailed: 'リクエストに失敗しました。クリックして再読み込みしてください',
    allowEnter:
      'フィードバックに画像を添付するため、写真とカメラへのアクセスを許可しますか',
    allow: '許可',
    deny: '拒否',
    CustomerSupport: 'カスタマーサポート',
    feedbackDescPlaceholder:
      '5文字以上の説明を入力してください（より適切なサポートのため）',
    replyRequired: '返信内容（必須）',
    myFeedback: 'マイフィードバック',
    submitSuccessDescSuffix: 'ページ',
    HelpFeedback: 'ヘルプとフィードバック'
  },
  ko: {
    FrequentlyAskedQuestions: '자주 묻는 질문',
    all: '모두',
    SubmitFeedback: '피드백 제출',
    homePage: '홈',
    feedbackType: '문제 유형',
    contactMethod: '연락처',
    contactMobile: '전화번호',
    contactWechat: '위챗',
    contactQq: 'QQ',
    contactLine: 'Line',
    contactEmail: '이메일',
    contactPlaceholder: '입력해 주세요',
    submit: '제출',
    mobileInvalid: '전화번호 입력 오류',
    emailInvalid: '이메일 입력 오류',
    ContactCannotBeEmpty: '연락처는 필수입니다',
    Helpful: '도움이 되었습니다',
    NotHelpful: '도움이 되지 않았습니다',
    NotSubmittedYet: '아직 피드백을 제출하지 않았습니다',
    FeedbackList: '피드백 목록',
    submitSuccess: '제출 성공',
    submitSuccessDescPrefix:
      '피드백을 주셔서 감사합니다. "사용자 피드백 - 내 피드백" 페이지에서 답변을 확인할 수 있습니다: ',
    gotIt: '알겠습니다',
    NoMore: '더 이상 없습니다',
    FeedbackDetails: '피드백 세부 정보',
    feedbackDescRequired: '문제 설명',
    SubmissionTime: '제출 시간',
    ProcessingStatus: '처리 상태',
    FeedbackResponse: '피드백 회신',
    appendReply: '추가 회신',
    NoResponseReceived: '아직 회신을 받지 못했습니다',
    OperationSuccessful: '작업 성공',
    HasYourFeedbackBeenResolved: '귀하의 피드백이 해결되었습니까?',
    NotResolved: '미해결',
    Resolved: '해결됨',
    IssueImage: '문제 이미지',
    uploadImagesMax3: '이미지 업로드 (최대 3장)',
    chooseFeedbackType: '피드백 유형을 선택해 주세요',
    contentRequired: '내용은 필수입니다',
    contentMin5: '내용은 5자 이상이어야 합니다',
    Pending: '처리 대기 중',
    Processed: '처리 완료',
    Processing: '처리 중',
    UnknownStatus: '알 수 없는 상태',
    Loading: '로딩 중',
    Requestfailed: '요청 실패, 클릭하여 다시 로드하세요',
    allowEnter:
      '피드백에 이미지를 첨부하기 위해 사진 및 카메라 접근을 허용하시겠습니까?',
    allow: '허용',
    deny: '거부',
    CustomerSupport: '고객 지원',
    feedbackDescPlaceholder:
      '더 나은 지원을 위해 5자 이상의 설명을 입력해 주세요',
    replyRequired: '회신 내용 (필수)',
    myFeedback: '내 피드백',
    submitSuccessDescSuffix: '페이지',
    HelpFeedback: '도움말 및 피드백'
  },
  de: {
    FrequentlyAskedQuestions: 'Häufig gestellte Fragen',
    all: 'Alle',
    SubmitFeedback: 'Feedback',
    homePage: 'Startseite',
    feedbackType: 'Problemart',
    contactMethod: 'Kontaktinformationen',
    contactMobile: 'Telefonnummer',
    contactWechat: 'WeChat',
    contactQq: 'QQ',
    contactLine: 'Line',
    contactEmail: 'E-Mail',
    contactPlaceholder: 'Bitte geben Sie ein',
    submit: 'Absenden',
    mobileInvalid: 'Ungültige Telefonnummer',
    emailInvalid: 'Ungültige E-Mail-Adresse',
    ContactCannotBeEmpty: 'Kontaktinformationen dürfen nicht leer sein',
    Helpful: 'Hilfreich',
    NotHelpful: 'Nicht hilfreich',
    NotSubmittedYet: 'Sie haben noch keine Feedbacks gesendet',
    FeedbackList: 'Feedback-Liste',
    submitSuccess: 'Erfolgreich gesendet',
    submitSuccessDescPrefix:
      'Vielen Dank für Ihr Feedback. Sie können die Antwort auf der Seite "Benutzerfeedback - Mein Feedback" einsehen: ',
    gotIt: 'Verstanden',
    NoMore: 'Keine weiteren',
    FeedbackDetails: 'Feedback-Details',
    feedbackDescRequired: 'Problembeschreibung',
    SubmissionTime: 'Absendezeit',
    ProcessingStatus: 'Bearbeitungsstatus',
    FeedbackResponse: 'Feedback-Antwort',
    appendReply: 'Zusätzliche Antwort',
    NoResponseReceived: 'Noch keine Antwort erhalten',
    OperationSuccessful: 'Erfolgreich durchgeführt',
    HasYourFeedbackBeenResolved: 'Ist Ihr Feedback behoben worden?',
    NotResolved: 'Nicht gelöst',
    Resolved: 'Gelöst',
    IssueImage: 'Problem-Bild',
    uploadImagesMax3: 'Bild hochladen (bis zu 3)',
    chooseFeedbackType: 'Bitte wählen Sie den Feedback-Typ',
    contentRequired: 'Inhalt darf nicht leer sein',
    contentMin5: 'Der Inhalt muss mindestens 5 Zeichen lang sein',
    Pending: 'Ausstehend',
    Processed: 'Verarbeitet',
    Processing: 'In Bearbeitung',
    UnknownStatus: 'Unbekannter Status',
    Loading: 'Wird geladen',
    Requestfailed: 'Anfrage fehlgeschlagen, klicken Sie zum Neuladen',
    allowEnter:
      'Zugriff auf Fotos und Kamera erlauben, um Bilder im Feedback anzuhängen?',
    allow: 'Zulassen',
    deny: 'Ablehnen',
    CustomerSupport: 'Kundensupport',
    feedbackDescPlaceholder:
      'Bitte geben Sie eine Beschreibung mit mindestens 5 Zeichen ein, damit wir Ihnen besser helfen können',
    replyRequired: 'Antwortinhalt (erforderlich)',
    myFeedback: 'Mein Feedback',
    submitSuccessDescSuffix: 'Seite',
    HelpFeedback: 'Hilfe & Feedback'
  },
  es: {
    FrequentlyAskedQuestions: 'Preguntas frecuentes',
    all: 'Todos',
    SubmitFeedback: 'Comentarios',
    homePage: 'Inicio',
    feedbackType: 'Tipo de problema',
    contactMethod: 'Información de contacto',
    contactMobile: 'Número de teléfono',
    contactWechat: 'WeChat',
    contactQq: 'QQ',
    contactLine: 'Line',
    contactEmail: 'Correo electrónico',
    contactPlaceholder: 'Por favor, ingrese',
    submit: 'Enviar',
    mobileInvalid: 'Número de teléfono inválido',
    emailInvalid: 'Dirección de correo electrónico inválida',
    ContactCannotBeEmpty: 'La información de contacto no puede estar vacía',
    Helpful: 'Útil',
    NotHelpful: 'No útil',
    NotSubmittedYet: 'Aún no ha enviado ningún comentario',
    FeedbackList: 'Lista de comentarios',
    submitSuccess: 'Enviado con éxito',
    submitSuccessDescPrefix:
      'Gracias por sus comentarios. Puede ver la respuesta en la página "Comentarios del usuario - Mis comentarios": ',
    gotIt: 'Entendido',
    NoMore: 'No hay más',
    FeedbackDetails: 'Detalles de los comentarios',
    feedbackDescRequired: 'Descripción del problema',
    SubmissionTime: 'Hora de envío',
    ProcessingStatus: 'Estado de procesamiento',
    FeedbackResponse: 'Respuesta a los comentarios',
    appendReply: 'Respuesta adicional',
    NoResponseReceived: 'Aún no se ha recibido respuesta',
    OperationSuccessful: 'Operación exitosa',
    HasYourFeedbackBeenResolved: '¿Se han resuelto sus comentarios?',
    NotResolved: 'No resuelto',
    Resolved: 'Resuelto',
    IssueImage: 'Imagen del problema',
    uploadImagesMax3: 'Subir imagen (hasta 3)',
    chooseFeedbackType: 'Por favor, seleccione el tipo de comentario',
    contentRequired: 'El contenido no puede estar vacío',
    contentMin5: 'El contenido debe tener al menos 5 caracteres',
    Pending: 'Pendiente',
    Processed: 'Procesado',
    Processing: 'En proceso',
    UnknownStatus: 'Estado desconocido',
    Loading: 'Cargando',
    Requestfailed: 'Solicitud fallida, haga clic para recargar',
    allowEnter:
      'Permitir acceso a fotos y cámara para adjuntar imágenes en los comentarios',
    allow: 'Permitir',
    deny: 'Denegar',
    CustomerSupport: 'Atención al cliente',
    feedbackDescPlaceholder:
      'Ingrese una descripción de al menos 5 caracteres para ayudarnos a asistirle mejor',
    replyRequired: 'Contenido de la respuesta (obligatorio)',
    myFeedback: 'Mis comentarios',
    submitSuccessDescSuffix: 'página',
    HelpFeedback: 'Ayuda y comentarios'
  },
  'zh-TW': {
    FrequentlyAskedQuestions: '常見問題',
    all: '全部',
    SubmitFeedback: '提交反饋',
    homePage: '首頁',
    feedbackType: '問題類型',
    contactMethod: '聯絡方式',
    contactMobile: '手機號',
    contactWechat: '微信',
    contactQq: 'QQ',
    contactLine: 'Line',
    contactEmail: '郵箱',
    contactPlaceholder: '請輸入',
    submit: '提交',
    mobileInvalid: '手機號輸入有誤',
    emailInvalid: '郵箱輸入有誤',
    ContactCannotBeEmpty: '聯絡方式不能為空',
    Helpful: '有幫助',
    NotHelpful: '沒幫助',
    NotSubmittedYet: '您暫未提交任何反饋',
    FeedbackList: '反饋列表',
    submitSuccess: '提交成功',
    submitSuccessDescPrefix: '感謝您的反饋，您可以在',
    gotIt: '知道了',
    NoMore: '沒有更多了',
    FeedbackDetails: '反饋詳情',
    feedbackDescRequired: '問題描述',
    SubmissionTime: '提交時間',
    ProcessingStatus: '處理狀態',
    FeedbackResponse: '反饋回覆',
    appendReply: '追加回覆',
    NoResponseReceived: '暫未收到回覆',
    OperationSuccessful: '操作成功',
    HasYourFeedbackBeenResolved: '您的反饋是否得到解決？',
    NotResolved: '未解決',
    Resolved: '已解決',
    IssueImage: '問題圖片',
    uploadImagesMax3: '上傳圖片（最多3張）',
    chooseFeedbackType: '請選擇反饋類型',
    contentRequired: '內容不能為空',
    contentMin5: '內容不能少於5字',
    Pending: '待處理',
    Processed: '已處理完成',
    Processing: '處理中',
    UnknownStatus: '未知狀態',
    Loading: '載入中',
    Requestfailed: '請求失敗，點擊重新加載',
    allowEnter: '是否允許存取系統相簿與相機，用於意見回饋附加圖片',
    allow: '允許',
    deny: '拒絕',
    CustomerSupport: '客服',
    feedbackDescPlaceholder: '請填寫5字以上描述，以便我們更好地為您提供幫助',
    replyRequired: '回覆內容（必填）',
    myFeedback: '我的反饋',
    submitSuccessDescSuffix: '頁面查看問題回覆',
    HelpFeedback: '幫助與回饋'
  },
  id: {
    FrequentlyAskedQuestions: 'Pertanyaan Umum',
    all: 'Semua',
    SubmitFeedback: 'Masukan',
    homePage: 'Beranda',
    feedbackType: 'Jenis Masalah',
    contactMethod: 'Informasi Kontak',
    contactMobile: 'Nomor Telepon',
    contactWechat: 'WeChat',
    contactQq: 'QQ',
    contactLine: 'Line',
    contactEmail: 'Email',
    contactPlaceholder: 'Silakan Masukkan',
    submit: 'Kirim',
    mobileInvalid: 'Nomor Telepon Tidak Valid',
    emailInvalid: 'Alamat Email Tidak Valid',
    ContactCannotBeEmpty: 'Informasi Kontak Tidak Boleh Kosong',
    Helpful: 'Bermanfaat',
    NotHelpful: 'Tidak Bermanfaat',
    NotSubmittedYet: 'Anda belum mengirimkan umpan balik apa pun',
    FeedbackList: 'Daftar Umpan Balik',
    submitSuccess: 'Berhasil Dikirim',
    submitSuccessDescPrefix:
      'Terima kasih atas maklum balas. Lihat respons di "Maklum Balas Saya".',
    gotIt: 'Mengerti',
    NoMore: 'Tidak Ada Lagi',
    FeedbackDetails: 'Detail Umpan Balik',
    feedbackDescRequired: 'Deskripsi masalah',
    SubmissionTime: 'Waktu Pengiriman',
    ProcessingStatus: 'Status Pemrosesan',
    FeedbackResponse: 'Tanggapan Umpan Balik',
    appendReply: 'Tanggapan Tambahan',
    NoResponseReceived: 'Belum Menerima Tanggapan',
    OperationSuccessful: 'Operasi Berhasil',
    HasYourFeedbackBeenResolved: 'Apakah Umpan Balik Anda Telah Diselesaikan?',
    NotResolved: 'Belum Diselesaikan',
    Resolved: 'Diselesaikan',
    IssueImage: 'Gambar Masalah',
    uploadImagesMax3: 'Unggah Gambar (Maks 3)',
    chooseFeedbackType: 'Silakan Pilih Jenis Umpan Balik',
    contentRequired: 'Isi Tidak Boleh Kosong',
    contentMin5: 'Isi Harus Minimal 5 Karakter',
    Pending: 'Tertunda',
    Processed: 'Diproses',
    Processing: 'Sedang Diproses',
    UnknownStatus: 'Status tidak diketahui',
    Loading: 'Memuat',
    Requestfailed: 'Permintaan gagal, klik untuk memuat ulang',
    allowEnter:
      'Izinkan akses ke foto dan kamera untuk melampirkan gambar dalam umpan balik',
    allow: 'Izinkan',
    deny: 'Tolak',
    CustomerSupport: 'Layanan pelanggan',
    feedbackDescPlaceholder:
      'Silakan masukkan deskripsi minimal 5 karakter agar kami dapat membantu Anda dengan lebih baik',
    replyRequired: 'Isi Tanggapan (Wajib)',
    myFeedback: 'Umpan Balik Saya',
    submitSuccessDescSuffix: 'halaman',
    HelpFeedback: 'Bantuan & Masukan'
  },
  ms: {
    FrequentlyAskedQuestions: 'Soalan Lazim',
    all: 'Semua',
    SubmitFeedback: 'Maklum balas',
    homePage: 'Laman Utama',
    feedbackType: 'Jenis Masalah',
    contactMethod: 'Maklumat Hubungan',
    contactMobile: 'Nombor Telefon',
    contactWechat: 'WeChat',
    contactQq: 'QQ',
    contactLine: 'Line',
    contactEmail: 'Email',
    contactPlaceholder: 'Sila Masukkan',
    submit: 'Hantar',
    mobileInvalid: 'Nombor Telefon Tidak Sah',
    emailInvalid: 'Alamat Email Tidak Sah',
    ContactCannotBeEmpty: 'Maklumat Hubungan Tidak Boleh Kosong',
    Helpful: 'Berguna',
    NotHelpful: 'Tidak Berguna',
    NotSubmittedYet: 'Anda belum menghantar sebarang maklum balas',
    FeedbackList: 'Senarai Maklum Balas',
    submitSuccess: 'Berjaya Dihantar',
    submitSuccessDescPrefix:
      'Terima kasih atas maklum balas anda. Respons boleh dilihat di "Maklum Balas Saya".',
    gotIt: 'Faham',
    NoMore: 'Tiada Lagi',
    FeedbackDetails: 'Butiran Maklum Balas',
    feedbackDescRequired: 'Penerangan masalah',
    SubmissionTime: 'Waktu Penghantaran',
    ProcessingStatus: 'Status Pemprosesan',
    FeedbackResponse: 'Respons Maklum Balas',
    appendReply: 'Respons Tambahan',
    NoResponseReceived: 'Belum Menerima Respons',
    OperationSuccessful: 'Operasi Berjaya',
    HasYourFeedbackBeenResolved: 'Adakah Maklum Balas Anda Telah Diselesaikan?',
    NotResolved: 'Belum Diselesaikan',
    Resolved: 'Diselesaikan',
    IssueImage: 'Gambar Masalah',
    uploadImagesMax3: 'Muat Naik Gambar (Sehingga 3)',
    chooseFeedbackType: 'Sila Pilih Jenis Maklum Balas',
    contentRequired: 'Kandungan Tidak Boleh Kosong',
    contentMin5: 'Kandungan Mesti Sekurang-kurangnya 5 Aksara',
    Pending: 'Tertunda',
    Processed: 'Diproses',
    Processing: 'Sedang Diproses',
    UnknownStatus: 'Status tidak diketahui',
    Loading: 'Memuat',
    Requestfailed: 'Permintaan gagal, klik untuk muat semula',
    allowEnter:
      'Benarkan akses ke foto dan kamera untuk melampirkan imej dalam maklum balas',
    allow: 'Benarkan',
    deny: 'Tolak',
    CustomerSupport: 'Khidmat pelanggan',
    feedbackDescPlaceholder:
      'Sila masukkan huraian sekurang-kurangnya 5 aksara supaya kami dapat membantu anda dengan lebih baik',
    replyRequired: 'Kandungan Respons (Diperlukan)',
    myFeedback: 'Maklum Balas Saya',
    submitSuccessDescSuffix: 'halaman',
    HelpFeedback: 'Bantuan & Maklum Balas'
  },
  th: {
    FrequentlyAskedQuestions: 'คำถามทั่วไป',
    all: 'ทั้งหมด',
    SubmitFeedback: 'ส่งคำติชม',
    homePage: 'หน้าแรก',
    feedbackType: 'ประเภทปัญหา',
    contactMethod: 'ข้อมูลการติดต่อ',
    contactMobile: 'หมายเลขโทรศัพท์',
    contactWechat: 'WeChat',
    contactQq: 'QQ',
    contactLine: 'Line',
    contactEmail: 'อีเมล',
    contactPlaceholder: 'กรุณากรอก',
    submit: 'ส่ง',
    mobileInvalid: 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
    emailInvalid: 'อีเมลไม่ถูกต้อง',
    ContactCannotBeEmpty: 'ข้อมูลการติดต่อไม่สามารถว่างได้',
    Helpful: 'มีประโยชน์',
    NotHelpful: 'ไม่มีประโยชน์',
    NotSubmittedYet: 'คุณยังไม่ได้ส่งคำติชมใดๆ',
    FeedbackList: 'รายการคำติชม',
    submitSuccess: 'ส่งสำเร็จ',
    submitSuccessDescPrefix:
      'ขอบคุณสำหรับคำติชมของคุณ คุณสามารถดูคำตอบได้ที่หน้า "คำติชมผู้ใช้ - คำติชมของฉัน": ',
    gotIt: 'เข้าใจแล้ว',
    NoMore: 'ไม่มีเพิ่มเติม',
    FeedbackDetails: 'รายละเอียดคำติชม',
    feedbackDescRequired: 'คำอธิบายปัญหา',
    SubmissionTime: 'เวลาส่ง',
    ProcessingStatus: 'สถานะการประมวลผล',
    FeedbackResponse: 'คำตอบคำติชม',
    appendReply: 'คำตอบเพิ่มเติม',
    NoResponseReceived: 'ยังไม่ได้รับคำตอบ',
    OperationSuccessful: 'ดำเนินการสำเร็จ',
    HasYourFeedbackBeenResolved: 'คำติชมของคุณได้รับการแก้ไขแล้วหรือไม่?',
    NotResolved: 'ยังไม่ได้รับการแก้ไข',
    Resolved: 'ได้รับการแก้ไขแล้ว',
    IssueImage: 'รูปภาพปัญหา',
    uploadImagesMax3: 'อัปโหลดรูปภาพ (สูงสุด 3 รูป)',
    chooseFeedbackType: 'กรุณาเลือกประเภทคำติชม',
    contentRequired: 'เนื้อหาไม่สามารถว่างได้',
    contentMin5: 'เนื้อหาต้องมีอย่างน้อย 5 ตัวอักษร',
    Pending: 'รอการประมวลผล',
    Processed: 'ประมวลผลเสร็จสิ้น',
    Processing: 'กำลังประมวลผล',
    UnknownStatus: 'สถานะไม่ทราบ',
    Loading: 'กำลังโหลด',
    Requestfailed: 'คำขอล้มเหลว คลิกเพื่อโหลดใหม่',
    allowEnter:
      'อนุญาตให้เข้าถึงรูปภาพและกล้องเพื่อแนบรูปในข้อเสนอแนะ',
    allow: 'อนุญาต',
    deny: 'ปฏิเสธ',
    CustomerSupport: 'ฝ่ายบริการลูกค้า',
    feedbackDescPlaceholder:
      'กรุณากรอกรายละเอียดอย่างน้อย 5 ตัวอักษร เพื่อให้เราสามารถช่วยเหลือคุณได้ดีขึ้น',
    replyRequired: 'เนื้อหาคำตอบ (จำเป็น)',
    myFeedback: 'คำติชมของฉัน',
    submitSuccessDescSuffix: 'หน้า',
    HelpFeedback: 'ช่วยเหลือและข้อเสนอแนะ'
  },
};